document.addEventListener("DOMContentLoaded", function () {
  // Tab switching
  document.querySelectorAll(".tab-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      document
        .querySelectorAll(".tab-btn")
        .forEach((b) => b.classList.remove("active"));
      document
        .querySelectorAll(".tab-content")
        .forEach((grid) => grid.classList.add("hidden"));
      btn.classList.add("active");
      document.getElementById(btn.dataset.tab).classList.remove("hidden");
    });
  });

  // Quantity increase
  document.querySelectorAll(".qty-btn.plus").forEach((btn) => {
    btn.addEventListener("click", () => {
      const val = btn.parentElement.querySelector(".qty-val");
      val.textContent = parseInt(val.textContent) + 1;
    });
  });

  // Quantity decrease
  document.querySelectorAll(".qty-btn.minus").forEach((btn) => {
    btn.addEventListener("click", () => {
      const val = btn.parentElement.querySelector(".qty-val");
      let count = parseInt(val.textContent);
      if (count > 1) val.textContent = count - 1;
    });
  });

  // Add to cart
  document.querySelectorAll(".cart-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const variantId = btn.dataset.id;
      const qty = parseInt(
        btn.parentElement.querySelector(".qty-val").textContent
      );

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: variantId, quantity: qty }),
      })
        .then((res) => res.json())
        .then(() => {
          // 1. Update header count
          document.dispatchEvent(new CustomEvent("cart:refresh"));

          fetch("/?section_id=cart-drawer")
            .then((res) => res.text())
            .then((html) => {
              const tempDiv = document.createElement("div");
              tempDiv.innerHTML = html;

              const newCartDrawer = tempDiv.querySelector("cart-drawer");
              const oldCartDrawer = document.querySelector("cart-drawer");

              if (newCartDrawer && oldCartDrawer) {
                oldCartDrawer.replaceWith(newCartDrawer);

                // Delay ensures new DOM is in place
                setTimeout(() => {
                  const refreshedDrawer = document.querySelector("cart-drawer");

                  // Open drawer
                  if (
                    refreshedDrawer &&
                    typeof refreshedDrawer.open === "function"
                  ) {
                    refreshedDrawer.open();
                  }

                  // ✅ Update the header cart count now
                  fetch("/cart.js")
                    .then((res) => res.json())
                    .then((cart) => {
                      const countBubble = document.querySelector(
                        ".cart-count-bubble span[aria-hidden]"
                      );
                      if (countBubble)
                        countBubble.textContent = cart.item_count;
                    });
                }, 100); // You can try 150 if needed
              }
            });
        })
        .catch((err) => console.error("Add to cart error:", err));
    });
  });
});
